if (!window.HouseMoneyHandler) {
  class HouseMoneyHandler {
    constructor() {
      this.emailInput = document.getElementById('house-money-email');
      this.messageEl = document.getElementById('house-money-message');
      this.applyButton = document.getElementById('apply-credit-and-checkout');
      this.checkoutButton = document.getElementById('checkout-primary');
      this.container = document.getElementById('house-money-container');
      this.cartForm = document.getElementById('cart');
      this.isApplying = false;

      console.log('HouseMoneyHandler constructor called');
      console.log('Email input:', this.emailInput);
      console.log('Email value:', this.emailInput?.value);
      console.log('Message element:', this.messageEl);
      console.log('Apply button:', this.applyButton);
      console.log('Checkout button:', this.checkoutButton);

      if (this.container?.dataset.hasDiscount === 'true') {
        console.log('Has discount, returning early');
        return;
      }

      if (window.houseMoneyHandlerInitialized) {
        console.log('HouseMoneyHandler already initialized. Skipping duplicate setup.');
        return;
      }
      window.houseMoneyHandlerInitialized = true;
      const termsCheckbox = document.getElementById('Cart-Terms');
      if (termsCheckbox && this.checkoutButton) {
        this.updateCheckoutButtonState(termsCheckbox.checked);
        termsCheckbox.addEventListener('change', (event) => {
          this.updateCheckoutButtonState(event.target.checked);
        });
      }
      // Add click handler for the apply button
      if (this.applyButton) {
        this.applyButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.applyDiscountAndCheckout();
        });
      }

      if (this.cartForm) {
        this.cartForm.addEventListener('submit', this.handleFormSubmit.bind(this));
      }
    }

    getEmail() {
      return this.emailInput?.value || '';
    }

    updateCheckoutButtonState(isChecked) {
      if (!this.checkoutButton) return;

      this.checkoutButton.disabled = !isChecked;
      if (!isChecked) {
        this.checkoutButton.style.opacity = '0.5';
        this.checkoutButton.style.cursor = 'not-allowed';
      } else {
        this.checkoutButton.style.opacity = '1';
        this.checkoutButton.style.cursor = 'pointer';
      }
    }

    /**
     * Intercepts form submission to handle the custom button click.
     */
    handleFormSubmit(event) {
      if (document.activeElement && document.activeElement.id === 'apply-credit-and-checkout') {
        event.preventDefault();
        this.applyDiscountAndCheckout();
      }
      // Let normal checkout button submit the form naturally
    }

    /**
     * Checks the customer's balance.
     */
    async checkHouseMoneyBalance() {
      const email = this.getEmail();
      
      if (!email || !this.messageEl) {
        console.log('Missing required elements', { email, messageEl: this.messageEl });
        return;
      }

      this.messageEl.textContent = 'Checking your store credit balance...';
      this.messageEl.style.display = 'block';

      try {
        const response = await fetch("https://house-money-worker.tnh542.workers.dev/get-house-money", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email })
        });

        if (!response.ok) throw new Error(`Server error: ${response.status}`);
        
        const data = await response.json();
        const balance = parseFloat(data.balance);

        if (data.success && balance > 0) {
          this.balance = balance;
          this.messageEl.textContent = `You have $${balance.toFixed(2)} in store credit.`;
          if (this.applyButton) {
            this.applyButton.style.display = 'block';
          }
        } else {
          this.messageEl.textContent = `You have $0.00 in store credit.`;
          if (this.applyButton) {
            this.applyButton.style.display = 'none';
          }
        }
      } catch (error) {
        console.error('Error checking store credit balance:', error);
        this.messageEl.textContent = 'Could not check your balance.';
        this.messageEl.style.color = 'red';
        if (this.applyButton) {
          this.applyButton.style.display = 'none';
        }
      }
    }

    /**
     * Applies the discount and redirects.
     */
    async applyDiscountAndCheckout() {
      const email = this.getEmail();
      
      if (!this.balance) {
        console.log('No balance to apply');
        return;
      }

      if (this.isApplying || window.houseMoneyApplyInFlight) {
        return;
      }

      if (!email) {
        console.error('No email found');
        this.messageEl.textContent = 'Error: Email not found.';
        this.messageEl.style.display = 'block';
        this.messageEl.style.color = 'red';
        return;
      }

      this.isApplying = true;
      window.houseMoneyApplyInFlight = true;

      console.log('Applying discount for balance:', this.balance, 'email:', email);

      this.applyButton.disabled = true;
      const buttonSpan = this.applyButton.querySelector('span');
      if (buttonSpan) buttonSpan.textContent = 'Applying...';

      try {
        let cartProductIds = [];
        let cartTotal = 0;
        let cartToken = null;
        let cartId = null;
        try {
          const cartResponse = await fetch('/cart.js');
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            cartProductIds = (cartData?.items || [])
              .map((item) => item?.product_id)
              .filter(Boolean);
            cartTotal = (cartData?.total_price || 0) / 100;
            cartToken = cartData?.token || null;
            cartId = cartData?.id || null;
          }
        } catch (cartError) {
          console.warn('Unable to fetch cart data for House Money:', cartError);
        }

        if (cartProductIds.length === 0 && Array.isArray(window.houseMoneyCartProductIds)) {
          cartProductIds = window.houseMoneyCartProductIds.filter(Boolean);
        }

        if (!cartTotal || cartTotal <= 0) {
          throw new Error('Unable to determine cart total. Please refresh and try again.');
        }

        const amountToApply = Math.max(0, this.balance);
        console.log('Cart total:', cartTotal, 'Balance:', this.balance, 'Amount to apply:', amountToApply);

        const response = await fetch("https://house-money-worker.tnh542.workers.dev/apply-discount", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            amount: amountToApply,
            cartProductIds,
            cartToken,
            cartId
          })
        });

        console.log('Response status:', response.status);
        console.log('Response ok:', response.ok);
        
        const data = await response.json();
        console.log('Discount response:', data);
        console.log('Discount code:', data.discount_code);
        console.log('Success:', data.success);
        console.log('Message:', data.message);

        const checkoutBase = `${window.location.origin}/checkout`;
        if (response.ok && data.gift_card_code) {
          const rawCode = String(data.gift_card_code || '').trim();
          const cleanedCode = rawCode.replace(/[-\s]/g, '').toUpperCase();
          const formattedCode = cleanedCode.length === 16
            ? cleanedCode.match(/.{1,4}/g).join('-')
            : cleanedCode;
          const encodedCode = encodeURIComponent(formattedCode);
          console.log('Redirecting to checkout with gift card:', formattedCode);
          window.location.href = `${checkoutBase}?discount=${encodedCode}&skip_shop_pay=true&shop_pay_checkout_as_guest=true`;
        } else if (response.ok && data.discount_code) {
          const discountCode = encodeURIComponent(data.discount_code);
          console.log('Redirecting to checkout with discount:', data.discount_code);
          window.location.href = `${checkoutBase}?discount=${discountCode}&skip_shop_pay=true&shop_pay_checkout_as_guest=true`;
        } else {
          throw new Error(data.message || data.error || 'Failed to apply discount.');
        }
      } catch (error) {
        console.error('Error applying discount:', error);
        this.messageEl.textContent = `Error: ${error.message}`;
        this.messageEl.style.display = 'block';
        this.messageEl.style.color = 'red';
        
        if (buttonSpan) buttonSpan.textContent = 'use store credit';
        this.applyButton.disabled = false;
        this.isApplying = false;
        window.houseMoneyApplyInFlight = false;
      }
    }
  }

  window.HouseMoneyHandler = HouseMoneyHandler;
}